import { FC } from 'react';
import { Box, Center, ThemeTypings } from '@chakra-ui/react';

import {
  TransactionCategory,
  TransactionPaymentMethod,
  TransactionStatus,
} from '__generated__/GQL';
import { TransactionEnrichmentFragment } from 'common/graphql/fragments/transactionEnrichment.gql';
import SunshineIcon from 'components/_core/SunshineIcon';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';

import mapTransactionToRebrandedCategoryIconProps from '../../mapTransactionToRebrandedCategoryIconProps';

type Size = 'md' | 'lg';

type TransactionForIconProps = {
  enrichment?: TransactionEnrichmentFragment | null;
  category: TransactionCategory;
  paymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  type: string;
};

interface TransactionIconProps {
  size?: Size;
  transaction: TransactionForIconProps;
  withColoredBackground?: boolean;
  isMergedTransaction?: boolean;
}

const sizeToDiameterInPx = {
  lg: 68,
  md: 40,
};

const sizeToIconSize = {
  lg: 'icon-31',
  md: 'icon-15',
} satisfies Record<Size, ThemeTypings['components']['SunshineIcon']['sizes']>;

const TransactionIcon: FC<TransactionIconProps> = ({
  isMergedTransaction = false,
  size = 'md',
  transaction,
  withColoredBackground = true,
}) => {
  const { enrichment } = transaction;
  const diameter = sizeToDiameterInPx[size];

  const { color, name } = mapTransactionToRebrandedCategoryIconProps({
    isMergedTransaction,
    transaction,
  });

  const icon = withColoredBackground ? (
    <SquircleIcon colorScheme={color} name={name} />
  ) : (
    <SunshineIcon colorScheme={color} name={name} size={sizeToIconSize[size]} />
  );

  return (
    <Center boxSize={diameter}>
      {enrichment?.logoFileBucket && enrichment.logoFileRef ? (
        <Box
          backgroundImage={`url(https://storage.googleapis.com/${enrichment.logoFileBucket}/${enrichment.logoFileRef})`}
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
          backgroundSize="contain"
          borderRadius="radius-full"
          boxSize={`${diameter}px`}
          overflow="hidden"
        />
      ) : (
        icon
      )}
    </Center>
  );
};

export default TransactionIcon;
